import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceService } from 'src/app/services/api-service.service';
import { environment } from 'src/environments/environment.development';
import { ReturnRefundModelComponent } from '../return-refund-model/return-refund-model.component';

@Component({
  selector: 'app-order-return',
  templateUrl: './order-return.component.html',
  styleUrls: ['./order-return.component.scss']
})
export class OrderReturnComponent implements OnInit {
  productImageUrl = environment.ImageBaseUrl;
  value: string = 'case1';

  // Return fields
  selectedReason: string = '';
  additionalInfo: string = '';
  videoFile: File | null = null;
  isNextEnabled: boolean = false;

  // Exchange fields
  selectedReasonExchange: string = '';
  additionalInfoExchange: string = '';
  isNextEnabledExchange: boolean = false;

  minLength: number = 5;
  productid: string = '';
  ordesDeails: any = null;
  orderimages: string = '';
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiServiceService,
private toaster : ToastrService,
public dialog: MatDialog // 👈 Inject MatDialog
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.productid = params['id'];
      this.getOrderById(this.productid);
    });
  }

  getOrderById(id: string): void {
    this.loading = true;
    this.api.getOrderById(id).subscribe({
      next: (res: any) => {
        this.ordesDeails = res.data;
        this.orderimages = this.ordesDeails.items[0]?.product_id?.images?.[0] || '';
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load order:', err);
        this.loading = false;
      }
    });
  }

  onVideoSelected(event: any): void {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      this.videoFile = file;
    } else {
      this.videoFile = null;
      this.toaster.warning('Please select a valid video file (MP4, MOV, etc.).');
    }
    this.checkButtonState();
  }

  checkButtonState(): void {
    const hasReason = this.selectedReason.trim() !== '';
    const hasVideo = this.videoFile !== null;
    this.isNextEnabled = hasReason && hasVideo;
  }

  checkButtonStateExchange(): void {
    this.isNextEnabledExchange = this.selectedReasonExchange.trim() !== '' ||
      this.additionalInfoExchange.trim().length >= this.minLength;
  }

  setValue(newValue: string): void {
    this.value = newValue;
  }

 submitReturnRequest(): void {
  if (!this.ordesDeails || !this.videoFile) return;

  const orderId = this.ordesDeails._id;
  const productId = this.ordesDeails.items[0].product_id._id;
  const reason = this.selectedReason  || 'No reason provided';
  const resaontext = this.additionalInfo  || 'No reason provided';

  const formData = new FormData();
  formData.append('orderId', orderId);
  formData.append('productId', productId);
  formData.append('reason', reason);
  formData.append('video', this.videoFile);
  formData.append('resaontext', resaontext);

  this.api.submitReturnRequest(formData).subscribe({
    next: (res: any) => {
      this.toaster.success('Return request submitted successfully!');

        // ✅ Open bank details modal instead of navigating
        const dialogRef = this.dialog.open(ReturnRefundModelComponent, {
          width: '500px',
          data: {
            orderId: orderId,
            returnRequestId: res.returnRequest?._id,
            amount: this.ordesDeails.total_amount
          }
        });


       this.router.navigate(['profile-details', { pageName: 'myorder' }]);
    },
    error: (err) => {
      console.error('Return submission failed:', err);

      // ✅ Handle specific error messages from backend
      if (err.error?.message) {
        const msg = err.error.message;

        if (msg.includes('already exists')) {
          this.toaster.warning('You have already requested a return for this product.');
        } else if (msg.includes('Return period has expired')) {
          this.toaster.warning('Sorry, the 7-day return window has expired.');
        } else if (msg.includes('Product video is required')) {
          this.toaster.error('Please upload a video showing the product issue.');
        } else if (msg.includes('All fields are required')) {
          this.toaster.error('Please select a return reason.');
        } else if (msg.includes('Product not found in this order')) {
          this.toaster.error('This product does not belong to the selected order.');
        } else {
          // Generic server or validation error
          this.toaster.error(msg);
        }
      } else {
        // Fallback for network errors, 500, etc.
        this.toaster.error('Failed to submit return request. Please try again later.');
      }
    }
  });
}
  exchangeOrderPage(): void {
    // You can implement similar logic for exchange later
    alert('Exchange feature coming soon!');
    // this.router.navigate(['/exchange-order']);
  }
}